import { ServiceFieldType } from '@onlog-public/additional-services-types';

import { OptionsCache } from '../services/optionsLoader/types';
import { AServicePropertyCache } from '../types';

/**
 * Дефолтный стейт кеша свойств доп. услуг.
 */
export class DefaultServicePropertyCacheState implements AServicePropertyCache {
  Cache = {
    tax: { isPartialLoading: true, cache: {} },
    currency: { isPartialLoading: true, cache: {} },
    location: { isPartialLoading: true, cache: {} },
    product: { isPartialLoading: true, cache: {} },
    package: { isPartialLoading: true, cache: {} },
    handbook: { isPartialLoading: true, cache: {} },
    consulting_contractor: { isPartialLoading: true, cache: {} },
    inspection_contractor: { isPartialLoading: true, cache: {} },
    customs_contractor: { isPartialLoading: true, cache: {} },
    certification_contractor: { isPartialLoading: true, cache: {} },
    insurance_contractor: { isPartialLoading: true, cache: {} },
  } as { [T in ServiceFieldType]: OptionsCache<any> };
  Options: {};
  LangID: '';
}
